import script from "./PolicySectionsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PolicySectionsPage.vue?vue&type=script&setup=true&lang=ts"

import "./PolicySectionsPage.vue?vue&type=style&index=0&id=30ae65ab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ae65ab"]])

export default __exports__